import React from "react";
import { useTranslation } from "react-i18next";
import Select from "react-select";

const turkishCharacterRegex = (keyword) => {
  return keyword
  .replace(/İ/g, 'I')
  .replace(/Ş/g, 'S')
  .replace(/Ç/g, 'C')
  .replace(/Ğ/g, 'G')
  .replace(/Ö/g, 'O')
  .replace(/Ü/g, 'U');
}

export default function MultiSelect({
  field,
  form: { touched, errors, setFieldValue },
  ...props
}) {
  const { t } = useTranslation();
  const values = props.options ? field.value ? 
      (Array.isArray(field.value) ? field.value : [field.value]).map((value) => {
        return props.options.find((option) => option.value === value);
      }) 
    : props.defaultValue ? { value: props.defaultValue, label: props.defaultLabel } : "" : "";

  const isOptionDisabled = props.maxLimit ? values.length >= props.maxLimit : false;

  return (
    <div className={"form-group col-md-" + (props.colNumber || 4)}>
      <label className="text-black font-w600">
        {props.label}
        {props.required ? "*" : ""}
        {props.buttonLabel}
      </label>
      <Select
        {...field}
        {...props}
        menuPlacement={props.menuPlacement || 'auto'}
        options={props.options || []}
        name={field.name}
        value={values}
        menuPortalTarget={document.body} 
        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
        onChange={(options) => {
          if (options) {
            setFieldValue(
              field.name,
              options.map((o) => o.value)
            );
            if (props.onChangeFunc) {
              props.onChangeFunc(options.map((o) => o.value), setFieldValue);
            }
          } else {            
            setFieldValue(field.name, []);
            if(props.onChangeFunc)
              props.onChangeFunc([])
          }
        }}
        filterOption={(candidate, input) => {
          return candidate.data.__isNew__ || turkishCharacterRegex(candidate.label.toLocaleUpperCase('tr-TR')).startsWith(turkishCharacterRegex(input.toLocaleUpperCase('tr-TR')));
        }}
        onBlur={field.onBlur}
        style={{
          minHeight: "45px",
          lineHeight: "50px",
          color: "#7e7e7e",
          paddingLeft: " 15px",
        }}
        isMulti
        maxMenuHeight={250}
        placeholder={<span>{props.placeholder || t("formFields.selectPlaceHolder")}</span>}
        isOptionDisabled={() => isOptionDisabled}
      />
      {errors[field.name] && (
        <span className="text-danger">
          <small>*{errors[field.name]}</small>
        </span>
      )}
    </div>
  );
}
